import { createI18nText } from '@hilma/netina2all';

const login = createI18nText({
	he: {
		code: 'קוד',
		codeText: 'הכנס את הקוד שקיבלת ב-SMS',
		profile: 'אזור אישי',
		welcome: 'ברוך הבא!',
		login: 'התחבר',
		sendCode: 'שלח קוד',
	},
	en: {
		code: 'Code',
		codeText: 'Enter the code you\'ve received via SMS',
		profile: 'Profile',
		welcome: 'Welcome!',
		login: 'Login',
		sendCode: 'Send Code'
	}
});

export default login;